import { useEffect, FC } from 'react';
import { useDispatch } from 'react-redux';
import { DocumentsContentWithLoader } from './loaders';
import { getAdditionalSettings, getDocuments } from '../../actions/docs';

export const Documents: FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAdditionalSettings());
        dispatch(getDocuments());
    }, []);

    return <DocumentsContentWithLoader />;
};
